import type { FunctionComponent } from 'react';
import { AbbCaretRight } from '@/assets/icons/components/abb-caret-right';
import { AbbUpload } from '@/assets/icons/components/abb-upload';
import { useNavigation } from '@/modules/utils/custom-hooks/use-navigation';
import { useTheme } from '@/modules/utils/custom-hooks/use-theme';
import { Button } from '@/ui-components/button/button';
import { Flexbox } from '@/ui-components/flexbox/flexbox';
import type { Data } from '@strapi/types';
import { useTranslations } from '@power-core/toolkit';

type ActionButtonsProps = {
	index: number;
	isDisabled: boolean;
	isLoading: boolean;
	card: Data.Entity<'api::document-type.document-type'>;
};

export const ActionButtons: FunctionComponent<ActionButtonsProps> = ({ index, isDisabled, isLoading, card }) => {
	const t = useTranslations();
	const { isDarkTheme } = useTheme();
	const { addSearchParam } = useNavigation();
	const { legacyUrl, title, legacyTitle } = card;

	const openCreateModal = () => {
		addSearchParam([
			{ key: 'modal', value: 'CreateDocument' },
			{ key: 'value', value: `${index}` },
		]);
	};

	const handleOpenLegacySoc = () => {
		if (legacyUrl) window.open(legacyUrl, '_blank');
	};

	if (!title) return null;

	return (
		<Flexbox justify='between' items='center' className='pt-2'>
			<div className='w-28'>
				<Button disabled={isDisabled} isLoading={isLoading} sizing='small' onClick={openCreateModal}>
					{t('T_CREATE')}
				</Button>
			</div>

			<div className={'w-fit'}>
				<Button
					disabled={isDisabled}
					isLoading={isLoading}
					variant='text'
					sizing='small'
					className='text-dark dark:text-white'
					iconPosition='left'
					icon={<AbbUpload size={20} fill={isDarkTheme ? '#f1f1f1' : '#1f1f1f'} />}
					onClick={() =>
						addSearchParam([
							{ key: 'modal', value: 'UploadDocument' },
							{ key: 'value', value: `${index}` },
						])
					}
				>
					{t('T_UPLOAD')}
				</Button>
			</div>

			{legacyUrl && (
				<div className={'w-fit'}>
					{
						<Button
							disabled={isDisabled}
							isLoading={isLoading}
							variant='text'
							sizing='small'
							className='text-dark dark:text-white'
							iconPosition='right'
							icon={<AbbCaretRight size={22} fill={isDarkTheme ? '#f1f1f1' : '#1f1f1f'} />}
							onClick={handleOpenLegacySoc}
						>
							{t(legacyTitle || 'T_OPEN_LEGACY')}
						</Button>
					}
				</div>
			)}
		</Flexbox>
	);
};
